function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "54.7,52.3 46.3,52.3 46.3,49.3 51.7,49.3 51.7,3.5 15.9,3.5 15.9,9 12.9,9 12.9,0.5 54.7,0.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M47.8,59.2H5.9V7.5h41.8V59.2z M8.9,56.2h35.8V10.5H8.9V56.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M26.4,45.1c-6.7,0-12.2-5.5-12.2-12.2c0-6.7,5.5-12.2,12.2-12.2s12.2,5.5,12.2,12.2C38.6,39.6,33.1,45.1,26.4,45.1z  M26.4,23.7c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2S31.4,23.7,26.4,23.7z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "37,34 23,34 23,23 26,23 26,31 37,31  "
})))));

var SvgGraphSheets = function SvgGraphSheets(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/graph-sheets.cd584ede.svg";
export { SvgGraphSheets as ReactComponent };